import { motion } from "framer-motion";
import { Leaf, ShieldCheck, HeartHandshake } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { TEAM_PHOTOS } from "../data/content";

const [SALON, PRODUCTS] = TEAM_PHOTOS;

const BADGES = [
  { icon: Leaf, text: "Cosmesi bio certificata" },
  { icon: ShieldCheck, text: "Operatrici qualificate" },
  { icon: HeartHandshake, text: "Cura personalizzata" },
];

export const About = () => (
  <section id="chi-siamo" className="relative bg-cream py-24 md:py-36 overflow-hidden" data-testid="about-section">
    <div className="container-x grid items-center gap-16 lg:grid-cols-12">
      <div className="relative lg:col-span-6">
        <Reveal className="relative">
          <div className="overflow-hidden rounded-[2rem] aspect-[9/16] max-w-sm mx-auto lg:mx-0 shadow-[0_40px_80px_-40px_rgba(27,41,33,0.45)]">
            <motion.img
              src={SALON}
              alt="La titolare, Beauty Longevity Specialist"
              loading="lazy"
              className="h-full w-full object-cover"
              whileHover={{ scale: 1.04 }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
        </Reveal>
        <Reveal delay={0.25} className="absolute -bottom-10 left-0 sm:left-auto sm:right-0 lg:right-auto lg:left-[23.25rem] w-40 md:w-52">
          <div className="overflow-hidden rounded-2xl border-[6px] border-cream shadow-[0_24px_50px_-20px_rgba(27,41,33,0.4)] aspect-[3/4]">
            <img src={PRODUCTS} alt="La titolare davanti al murale del soffione" loading="lazy" className="h-full w-full object-cover object-top" />
          </div>
        </Reveal>
        <Reveal delay={0.35} className="absolute -top-6 -left-2 md:left-4 hidden sm:block">
          <div className="rounded-full bg-sage px-5 py-3 text-cream shadow-lg rotate-[-6deg]">
            <span className="font-serif text-2xl leading-none">quasi 30 anni</span>
            <span className="block text-[9px] uppercase tracking-[0.25em] text-cream/70">a Campodarsego</span>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6 lg:pl-8">
        <SectionHeading
          id="about"
          eyebrow="Chi Siamo"
          title={<>Un luogo dove la bellezza <em className="font-normal italic text-sage">fiorisce</em> e respira.</>}
        />
        <Reveal delay={0.2}>
          <p className="mt-8 text-base leading-relaxed text-muted">
            Biovital nasce a Reschigliano di Campodarsego da una convinzione semplice: prendersi cura di sé non dovrebbe mai
            essere una corsa. Da quasi trent'anni accogliamo le nostre clienti in un ambiente raccolto e luminoso, dove
            ogni trattamento inizia con l'ascolto e prosegue con protocolli costruiti su misura.
          </p>
          <p className="mt-5 text-base leading-relaxed text-muted">
            Abbiamo scelto la cosmesi biologica certificata perché crediamo che la pelle riconosca ciò che è autentico.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <blockquote className="mt-8 border-l-2 border-gold pl-6 font-serif text-2xl italic leading-snug text-ink">
            "La nostra missione è il benessere naturale: bellezza che nasce dall'equilibrio, non dalla fretta."
          </blockquote>
        </Reveal>
        <Reveal delay={0.4} className="mt-10 flex flex-wrap gap-3">
          {BADGES.map((b) => (
            <span key={b.text} className="inline-flex items-center gap-2 rounded-full border border-sage/15 bg-white px-4 py-2 text-xs font-semibold text-sage">
              <b.icon className="h-4 w-4 text-gold" /> {b.text}
            </span>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);
